export default __webpack_public_path__ + "assets/ico_objects_to_coown-5d4ce4e7.svg";